import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const orbs = [
  { size: 400, color: 'rgba(0,212,255,0.06)', x: '15%', startY: 200, speed: 0.15 },
  { size: 300, color: 'rgba(0,102,255,0.05)', x: '70%', startY: 800, speed: 0.1 },
  { size: 350, color: 'rgba(0,255,208,0.04)', x: '50%', startY: 1800, speed: 0.2 },
  { size: 380, color: 'rgba(0,212,255,0.05)', x: '80%', startY: 2800, speed: 0.12 },
  { size: 320, color: 'rgba(0,102,255,0.04)', x: '20%', startY: 3800, speed: 0.18 },
  { size: 400, color: 'rgba(0,255,208,0.03)', x: '55%', startY: 5000, speed: 0.08 },
  { size: 280, color: 'rgba(0,212,255,0.05)', x: '35%', startY: 6000, speed: 0.14 },
];

function FloatingOrb({ orb }) {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 10000], [orb.startY, orb.startY - 10000 * orb.speed]);

  return (
    <motion.div
      style={{
        y,
        position: 'absolute',
        left: orb.x,
        width: orb.size,
        height: orb.size,
        borderRadius: '50%',
        background: orb.color,
        filter: `blur(${orb.size * 0.2}px)`,
        transform: `translateX(-50%)`,
        willChange: 'transform',
      }}
    />
  );
}

export default function FloatingOrbs() {
  return (
    <div 
      className="pointer-events-none fixed inset-0 z-0" 
      data-testid="floating-orbs"
      style={{ 
        overflow: 'hidden',
        width: '100%',
        height: '100%',
      }}
    >
      {orbs.map((orb, i) => (
        <FloatingOrb key={i} orb={orb} />
      ))}
    </div>
  );
}
